import { Tooltip, TooltipContent, TooltipTrigger } from '@tempo-io/sui-tooltip';
import { useEffect, useRef, useState } from 'react';
import { ItemStatusBadge } from '@/components/ui/itemStatusBadge';
import type { ItemStatus } from '@/lib/api/types/itemStatus';

export const ItemStatusCell = ({ value }: { value?: ItemStatus }) => {
  const wrapperRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependency array is intentionally limited to prevent excessive re-renders
  useEffect(() => {
    const wrapper = wrapperRef.current;
    if (wrapper) {
      const badgeElement = wrapper.firstElementChild;
      if (badgeElement instanceof HTMLElement) {
        setIsTruncated(badgeElement.scrollWidth > badgeElement.clientWidth);
      }
    }
  }, [value?.name]);

  if (!value) return null;

  const badge = (
    <div ref={wrapperRef} className="flex max-w-full">
      <ItemStatusBadge
        color={value.color}
        label={value.name}
        className="truncate max-w-full inline-block"
      />
    </div>
  );

  if (!isTruncated) return badge;

  return (
    <Tooltip>
      <TooltipTrigger asChild className="block max-w-full">
        {badge}
      </TooltipTrigger>
      <TooltipContent>{value.name}</TooltipContent>
    </Tooltip>
  );
};
